<template>
  <div class="menu-top">
    <v-toolbar height="64" :dark="darkEnabled">
      <v-app-bar-nav-icon class="hide-on-desktop" @click="changeMenuLeft">
        <v-icon size="20" :color="toolbarIconColor">fas fa-bars</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/admin"
          ><img class="logo-menu" src="@/assets/logo-lifeapps.png"
        /></router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items class="menu-right">
        <v-btn
          class="btn-font-size"
          text
          :aria-label="darkEnabled ? 'Usar tema claro' : 'Usar tema escuro'"
          @click="toggleDarkMode"
        >
          <v-icon size="15">{{
            darkEnabled ? "fas fa-sun" : "fas fa-moon"
          }}</v-icon>
        </v-btn>
        <v-btn class="btn-font-size" text @click="logout"
          ><v-icon size="15">fas fa-sign-out-alt</v-icon></v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MENU_TOGGLE, MENU_TOGGLE_DARK_MODE } from "../store/actions/menu";
import { AUTH_LOGOUT } from "../store/actions/auth";
export default {
  name: "NavBarTop",
  computed: {
    ...mapGetters(["darkEnabled"]),
    toolbarIconColor() {
      return this.darkEnabled
        ? "rgba(255, 255, 255, 0.87)"
        : "rgba(0, 0, 0, 0.87)";
    }
  },
  methods: {
    toggleDarkMode() {
      this.$store.dispatch(MENU_TOGGLE_DARK_MODE);
    },
    async logout() {
      try {
        await this.$store.dispatch(AUTH_LOGOUT);
      } catch (error) {
        this.$router.replace({ path: "/login" });
      }
    },
    changeMenuLeft() {
      this.$store.dispatch(MENU_TOGGLE);
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-top {
  position: fixed;
  width: 100%;
  .logo-menu {
    max-width: 140px;
    max-height: 100%;
    width: auto;
    height: auto;
  }
  z-index: 800;
  .icon-novidade {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-right: 5px;
  }
  .badge-novidade {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #d93534;
    position: absolute;
    top: 1px;
    right: -2px;
  }
  .fixed-heigth {
    height: 64px !important;
  }
}
.v-toolbar__content {
  height: 64px !important;
}
@media (min-width: 768px) {
  .hide-on-desktop {
    display: none;
  }
}

@media (max-width: 768px) {
  .menu-right {
    display: none;
  }
}
</style>
